var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44 2.89172C2.24 2.89172 2.88 2.24172 2.88 1.45172C2.88 0.661719 2.23 0.0117188 1.44 0.0117188C0.65 0.0117188 0 0.661719 0 1.45172C0 2.24172 0.65 2.89172 1.44 2.89172ZM4.25 3.98172V12.0017H6.73V8.04172C6.73 6.99172 6.93 5.98172 8.22 5.98172C9.51 5.98172 9.51 7.18172 9.51 8.10172V12.0017H12V7.60172C12 5.44172 11.54 3.78172 9.02 3.78172C7.81 3.78172 7 4.44172 6.67 5.07172H6.64V3.97172H4.26L4.25 3.98172ZM0.2 3.98172H2.69V12.0017H0.2V3.98172Z",
    fill: "#4F46E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f2d14697930c053a644840da8d89ea38.svg";
export { ForwardRef as ReactComponent };